import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import {MsalService} from '@azure/msal-angular';
import { Observable } from 'rxjs/Observable';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
//import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Injectable()
export class InsertAuthTokenInterceptor implements HttpInterceptor {

    constructor(private msal: MsalService) { }
   /* intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return Observable.fromPromise(this.handleAccess(request, next));
    
      }
      private async handleAccess(request: HttpRequest<any>, next: HttpHandler):

    Promise<HttpEvent<any>> {
        var req = request.clone({
            headers: request.headers.set(
                'UserEmail',  this.msal.instance.getActiveAccount().username,
                )
            });
      return next.handle(req).toPromise();
    }*/

    // intercept(req: HttpRequest<any>, next: HttpHandler) {
    //     // get api url from adal config
    //     const resource = this.adal.GetResourceForEndpoint(req.url);
    //     if (!resource || !this.adal.isAuthenticated) {
    //         return next.handle(req);
    //     }
    //     const idtoken = sessionStorage.getItem('adal.idtoken');
    //     // merge the bearer token into the existing headers
    //     return this.adal.acquireToken(resource).pipe(
    //         mergeMap((token: string) => {
    //             let headers = new HttpHeaders().set('Authorization', `Bearer ${idtoken}`); // create header object
    //                 headers = headers.append('Cache-Control', 'no-cache'); // add a new header, creating a new object
    //                 headers = headers.append('X-XSS-Protection', '1; mode=block'); // add another header
    //                 headers = headers.append('Content-Security-Policy', "default-src 'self'");
    //                 headers = headers.append('Access-Control-Allow-Origin', "*");
    //                 if((!req.url.includes('ManageDoc'))||(!req.url.includes('TopicCard'))||(!req.url.includes('LogoIconMgmt'))||(!req.url.includes('User'))){
    //                     headers = headers.append('Content-Type', "application/json;charset=utf-8");
    //                 }

    //             const authorizedRequest = req.clone({
    //                 headers: headers                    
    //             });
    //             return next.handle(authorizedRequest);
    //     }));
    // }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        console.log(req);
        if (this.msal.instance.getActiveAccount() == null) {
            return next.handle(req);
        }
        
            var silentRequest: SilentRequest ={
                account: this.msal.instance.getActiveAccount(),
                scopes: ["user.read"]
            };
            return this.msal.acquireTokenSilent(silentRequest).pipe(
                mergeMap((tokenResponse: AuthenticationResult) => {
                    req = req.clone({
                        headers: req.headers.set('Authorization', `Bearer ${tokenResponse.idToken}`)
                        });
                        req = req.clone({
                            headers: req.headers.set(
                                'UserEmail',  tokenResponse.account.username,
                                )
                            });
                        
                            req = req.clone({
                                headers: req.headers.append('Cache-Control', 'no-cache') // add a new header, creating a new object
                                });
                                req = req.clone({
                                    headers :req.headers.append('X-XSS-Protection', '1; mode=block') // add another header
                                    });
                                    req = req.clone({
                                        headers :req.headers.append('Content-Security-Policy', "font-src *;img-src * data:;")
                                        //headers :req.headers.append('Content-Security-Policy', "default-src 'self'")
                                        });
                                        req = req.clone({
                                            headers :req.headers.append('Access-Control-Allow-Origin', "*")
                                            });
                                            req = req.clone({
                                                headers :req.headers.append('X-Content-Type-Options', "nosniff")
                                                });
                                                req = req.clone({
                                                    headers :req.headers.append('Strict-Transport-Security', "max-age=31536000; includeSubDomains")
                                                    });
     
                    return next.handle(req).do((event: HttpEvent<any>)=> {
    
                        },
                        (error: any)=> {
                            if (error instanceof HttpErrorResponse) {
                                if (error.status === 401) {
                                    //this.renewToken();
                                }
                            }
                        }
                    );
            }));
        
    }
        // get api url from adal config
       /*  const resource = this.msal.instance.GetResourceForEndpoint(req.url);
        if (!resource || !this.msal.isAuthenticated) {
            return next.handle(req);
        }
 
        // merge the bearer token into the existing headers
        return this.msal.acquireToken(resource).pipe(
            mergeMap((token: string) => {
                req = req.clone({
                    headers: req.headers.set('Authorization', `Bearer ${token}`)
                    });
                    req = req.clone({
                        headers: req.headers.set(
                            'UserEmail',  this.msal.userInfo.profile.upn,
                            )
                        });
                    
                        req = req.clone({
                            headers: req.headers.append('Cache-Control', 'no-cache') // add a new header, creating a new object
                            });
                            req = req.clone({
                                headers :req.headers.append('X-XSS-Protection', '1; mode=block') // add another header
                                });
                                req = req.clone({
                                    headers :req.headers.append('Content-Security-Policy', "font-src *;img-src * data:;")
                                    //headers :req.headers.append('Content-Security-Policy', "default-src 'self'")
                                    });
                                    req = req.clone({
                                        headers :req.headers.append('Access-Control-Allow-Origin', "*")
                                        });
                                        req = req.clone({
                                            headers :req.headers.append('X-Content-Type-Options', "nosniff")
                                            });
                                            req = req.clone({
                                                headers :req.headers.append('Strict-Transport-Security', "max-age=31536000; includeSubDomains")
                                                });
 
                return next.handle(req).do((event: HttpEvent<any>)=> {

                    },
                    (error: any)=> {
                        if (error instanceof HttpErrorResponse) {
                            if (error.status === 401) {
                                //this.renewToken();
                            }
                        }
                    }
                );
        })); */
    }

    /* renewToken() {
        this.msal.RenewToken('https://graph.microsoft.com');
        this.msal.acquireToken('https://graph.microsoft.com').subscribe((token: string) => {           
        },
          (error) => {
            
            this.logout();    
          });
      } */

    /*logout() {       
        sessionStorage.clear();
        localStorage.clear()
        this.msal.logout();        
      }*/
    

